import React from 'react';
import { Button } from './ui/Button';
import { Clock, Battery, Activity } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-cream-100" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-dark-900 mb-4" data-id="element-146">
            Conoce el Método Circadian Stacking
          </h2>
          <p className="text-xl text-coral-600 font-medium" data-id="element-147">
            La ciencia detrás de tu transformación en 14 días
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-148">
          {/* Step 1 */}
          <div className="relative bg-white p-8 rounded-2xl shadow-sm border border-cream-200 text-center group hover:-translate-y-2 transition-transform duration-300" data-id="element-149">
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-coral-500 text-white rounded-full flex items-center justify-center font-bold text-xl shadow-lg" data-id="element-150">
              1
            </div>
            <div className="mt-6 mb-4 flex justify-center text-coral-400" data-id="element-151">
              <Clock size={48} strokeWidth={1.5} data-id="element-152" />
            </div>
            <h3 className="text-xl font-bold text-dark-900 mb-3" data-id="element-153">
              Sincronización
            </h3>
            <p className="text-gray-600" data-id="element-154">
              Sincroniza tus hábitos con tu reloj biológico para optimizar tu
              metabolismo natural.
            </p>
          </div>

          {/* Step 2 */}
          <div className="relative bg-white p-8 rounded-2xl shadow-sm border border-cream-200 text-center group hover:-translate-y-2 transition-transform duration-300" data-id="element-155">
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-coral-500 text-white rounded-full flex items-center justify-center font-bold text-xl shadow-lg" data-id="element-156">
              2
            </div>
            <div className="mt-6 mb-4 flex justify-center text-coral-400" data-id="element-157">
              <Activity size={48} strokeWidth={1.5} data-id="element-158" />
            </div>
            <h3 className="text-xl font-bold text-dark-900 mb-3" data-id="element-159">
              Desactivación
            </h3>
            <p className="text-gray-600" data-id="element-160">
              Apaga la señal de emergencia del cortisol que mantiene tu cuerpo
              en estado de alerta e inflamación.
            </p>
          </div>

          {/* Step 3 */}
          <div className="relative bg-white p-8 rounded-2xl shadow-sm border border-cream-200 text-center group hover:-translate-y-2 transition-transform duration-300" data-id="element-161">
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-coral-500 text-white rounded-full flex items-center justify-center font-bold text-xl shadow-lg" data-id="element-162">
              3
            </div>
            <div className="mt-6 mb-4 flex justify-center text-coral-400" data-id="element-163">
              <Battery size={48} strokeWidth={1.5} data-id="element-164" />
            </div>
            <h3 className="text-xl font-bold text-dark-900 mb-3" data-id="element-165">
              Recuperación
            </h3>
            <p className="text-gray-600" data-id="element-166">
              Recupera energía, sueño profundo y un abdomen visiblemente más
              plano.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto bg-sage-100 rounded-2xl p-8 md:p-10 text-center border border-sage-200" data-id="element-167">
          <p className="text-lg md:text-xl text-dark-800 font-medium leading-relaxed mb-8" data-id="element-168">
            "Este es el camino más corto para volver a sentirte tú misma.{' '}
            <br className="hidden md:block" data-id="element-169" />
            <span className="font-bold text-sage-700" data-id="element-170">
              Sin suplementos costosos. Sin horas de cardio.
            </span>{' '}
            <br className="hidden md:block" data-id="element-171" />
            Solo ciencia aplicada a tu rutina diaria."
          </p>
          <Button variant="primary" className="px-8 py-3 text-lg" data-id="element-172">
            QUIERO EMPEZAR HOY MISMO →
          </Button>
        </div>
      </div>
    </section>;
}